import type { CSSProperties, RefObject } from 'react';
import { createContext } from 'react';

import type { ViewTabsEnum } from '@/layouts/PA-Layout/constants';
import type { Type } from '@/types/chat';

export interface IHomeContext {
  mindId: string | undefined;
  mindName: string | undefined;
  type: Type;
  voiceMute: boolean; // 静音
  activeTab: ViewTabsEnum;
  styles: CSSProperties;
  contentPortalRef?: RefObject<HTMLDivElement | null>;
  scrollContainerRef?: RefObject<HTMLDivElement | null>;
  chatHomepageRoute?: string;
  chatCircleRoute?: string;
  setContext: (context: Partial<IHomeContext>) => void;
}

const HomeContext = createContext<IHomeContext>({} as IHomeContext);

export default HomeContext;
